// react imports
import React, { useContext, useEffect, useState } from "react";
import {  useLocation, useNavigate } from "react-router-dom";
import prev from '../../assets/media/icons/prev.png'
import video_clock from '../../assets/media/icons/video-clock.png'
import video_play from '../../assets/media/icons/video-play.png'
import bookmark_filled from '../../assets/media/icons/bookmark-filled.png'
import bookmark_empty from '../../assets/media/icons/bookmark-empty.png'
import video from '../../assets/media/videos/video_1.mp4'
import ReactPlayer from 'react-player'
import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import AppContext from '../../AppContext';
import { MDBContainer
          } from 'mdb-react-ui-kit';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const VideosDetailPage = (props) => {

  const location = useLocation();
  const context = useContext(AppContext);

  // react router navigation
  const navigate = useNavigate();

  const [videoWidht, setVideoWidht] = useState(window.innerWidth < 1920 ? window.innerWidth : 1920);
  const [videoHeight, setVideoHeight] = useState(window.innerHeight < 1920*0.5625 ? window.innerHeight-8 : 1920*0.5625);
  const [isIframe, setIsIframe] = useState(false);
  const [isVideoHover, setIsVideoHover] = useState(false);
  const [isVideoHoverTwo, setIsVideoHoverTwo] = useState(false);
  const [videoList, setVideoList] = useState([]);
  const [starttime, setStarttime] = useState(false);


  const handleWindowSizeChange = () => {
    setVideoWidht(window.innerWidth < 1920 ? window.innerWidth : 1920);
    setVideoHeight(window.innerHeight < 1920*0.5625 ? window.innerHeight-8 : 1920*0.5625);
 
  };

  
  

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    setTimeout(() => {setStarttime(true) }, 300)
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    };
    
  }, []);


  useEffect(() => {
    
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setIsVideoHover(true)}, 300)
  }, []);


  useEffect(() => {
    context.interAxios.get('/video', function(response) {
        setVideoList(response.data.content)
    });
    
  
}, []);

  const onPutVideoToBookmark = (id) => {
    context.interAxios.put('/bookmark/' + id, function(response) {
        context.interAxios.get('/bookmark', function(response) {
            setBookmarkList(response.data)
        });
    });
}

const onDeleteVideoFromBookmark = (id) => {
    context.interAxios.delete('/bookmark/' + id, function(response) {
        context.interAxios.get('/bookmark', function(response) {
            setBookmarkList(response.data)
        });
    });
}

const truncateString = (str, num) => {
  if (str.length <= num) {
      return str
    }
        return str.slice(0, num) + '...'
}

const swiper = new Swiper('.swiper-more-video', {
  // Optional parameters
  modules: [FreeMode],
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 3,
      spaceBetween: 0
    },
    // when window width is >= 480px
    600: {
      slidesPerView: 4,
      spaceBetween: 0
    },
    // when window width is >= 640px
    760: {
      slidesPerView: 5,
      spaceBetween: 0
    }
  },
  direction: 'horizontal',
  loop: false,
  effect: 'slide',
  freeMode: {
    enabled: true,
    sticky: true,
  },
});
console.log(location.state.trainer)
  return (
    <MDBContainer fluid className="videodetail-container">
      <button className="black-button" type="button" onClick={() => {
                            if(location.state.categoryName !== undefined){
                              navigate('/videos', { state: { categoryName: location.state.categoryName, isTrainerModal: location.state.isTrainerModal, trainer:  location.state.trainer  } })
                            }else {
                              navigate('/videos')
                            }}}><img src={prev} alt="back"/><span>Back</span></button>
      
      <section className="first-section" id="">
        {!isIframe ? 
        <div className={isVideoHover ? "reactplayer-div hover-effect" : "reactplayer-div"}>
          <ReactPlayer
              className=''
              url= {video}
              width='100%'
              height='100%'
              controls = {false}
              onEnded = {() => {setIsVideoHover(false); setTimeout(() => {
                setIsIframe(true); }, 400); setTimeout(() => {
                  setIsVideoHoverTwo(true)}, 1500)} }
              playing={true}

          />
        </div>
        :
        <div className={isVideoHoverTwo ? "iframe-div hover-effect" : "reactplayer-div"}>
            <iframe src={location.state.video.fullUrl + "&controls=0&autoplay=1#t=" + parseInt(location.state.video.duration/180) + "m14s&end=" + parseInt(location.state.video.duration/3 + 120) }  width={videoHeight < videoWidht*0.5625 ? videoHeight/0.5625 :  videoWidht} height={videoHeight < videoWidht*0.5625 ? videoHeight : videoWidht*0.5625 +"px"} allowFullScreen="allowFullScreen" allow="autoplay"
              mozallowfullscreen="mozallowfullscreen" 
              msallowfullscreen="msallowfullscreen" 
              oallowfullscreen="oallowfullscreen" 
              webkitallowfullscreen="webkitallowfullscreen"></iframe>
        </div>
          }
      </section>
      <section className="detail-section">
        <div className="video-title">
          <span>
            {location.state.video.name}
          </span>
        </div>
        <div className="timer">
            <img src={video_clock} alt="timer"/>
            <span>{parseInt(location.state.video.duration/60) + "minutes"}</span>
        </div>
        <div className="play-button">
        <button type="button" onClick={() => { navigate('/videoplay', { state: { fullUrl: location.state.video.fullUrl, categoryName: undefined, isTrainerModal: location.state?.trainer ? true : false, trainer: location.state?.trainer } })}}><img src={video_play} alt="player"/></button>
        </div>
        <div className="video-description">
          <span>Lorem ipsum</span>
        </div>
        <div className="trainer-div">
          <img src={location.state.trainer?.pictureUrl} alt=""/>
          <span>
            {location.state.trainer?.name}
          </span>
        </div>
        <div className="bookmark-div">
          <button className="bookmark-button" type="button" onClick={location.state.video.isBookmarkList ? 
                            () => onDeleteVideoFromBookmark(location.state.video.id) : () => onPutVideoToBookmark(location.state.video.id)}>
            <img src={location.state.video.isBookmarkList ? bookmark_filled : bookmark_empty} alt="bookmark" />
          </button>
          <span>Add tom my favourites</span>
        </div>
      </section>
      {location.state.trainer[0] && (
        <section className="videolist-section">
          <div className="videolist-title">
            <span>More videos from this Trainer</span>
            <div className="trainer">
              <img src={location.state.trainer[0].profileImage?.thumbnailUrl} alt=""/>
              <span>{location.state.trainer[0].firstName + " " + location.state.trainer[0].lastName}</span>
            </div>
          </div>
          <div className="swiper-more-video">
            <div className="swiper-wrapper">
              {videoList.filter(k => k.trainerTag === location.state.trainer[0].trainerTag).map((k,n) => {  
                return(
                  <>
                  {starttime && (
                    <div class="swiper-slide" key={n}>
                    <div className="videocard-more-respo">
                        <div className="background-img" onClick={() => { navigate('/videodetail', { state: { video: k, trainer: location.state.trainer } })}}>
                          <img src={k.pictureUrl} alt="thumbnail-image"/>
                          <div className="more-text">
                            <span>{truncateString(k.name, 20)}</span>
                          </div>
                        </div>
                    </div>
                    </div>
                  )}
                  </>
                )
              })}
            </div>
          </div>
        </section>
      )}
     
    </MDBContainer>


  );
};

export default VideosDetailPage;
